import { create } from 'zustand'

type ThemeMode = 'light' | 'dark'

interface ThemeState {
  isDark: boolean
  toggleTheme: () => void
  setTheme: (mode: ThemeMode) => void
}

function applyTheme(mode: ThemeMode) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  root.classList.toggle('dark', mode === 'dark')
  root.style.colorScheme = mode
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  isDark: false,

  toggleTheme: () => {
    const next = !get().isDark
    applyTheme(next ? 'dark' : 'light')
    set({ isDark: next })
  },

  setTheme: (mode) => {
    applyTheme(mode)
    set({ isDark: mode === 'dark' })
  },
}))

export const getIsDark = () => useThemeStore.getState().isDark
